<template>
  <v-btn
    :id="id"
    :class="className"
    :type="type"
    :block="block"
    :depressed="depressed"
    :outlined="outlined"
    :disabled="disabled"
    :aria-label="text"
    :max-width="maxWidth"
    :min-width="minWidth"
    :width="width"
    :ripple="ripple"
    @click="onClick"
    :rounded="rounded"
    :text="flat"
    :color="color"
    :height="height"
    :link="link"
    :small="small"
    :data-uiid="dataUiid"
  >
    <div v-if="loading" class="d-flex align-center">
      <v-progress-circular
        indeterminate
        :color="loadingIconColor"
        size="27"
        aria-label="loading icon"
      ></v-progress-circular>
      <div
        class="ml-3"
        style="text-transform: initial"
        :class="[fontSize, textColor]"
      >
        {{ loadingText ? loadingText : text }}
      </div>
    </div>
    <div v-else class="btn-text d-flex align-center">
      <v-icon
        v-if="icon"
        :size="iconSize"
        :color="iconColor"
        class="icon__wrap bg-white mr-1"
        >{{ icon }}</v-icon
      >
      <div
        style="text-transform: initial"
        :class="[link ? 'text-decoration-underline' : '', fontSize, textColor]"
      >
        {{ text }}
      </div>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    link: {
      type: Boolean,
      default: false,
    },
    maxWidth: String,
    minWidth: String,
    width: String,
    height: String,
    id: String,
    className: String,
    text: String,
    textColor: String,
    loadingText: String,
    disabled: Boolean,
    invalid: Boolean,
    loading: Boolean,
    loadingIconColor: String,
    block: Boolean,
    depressed: Boolean,
    outlined: Boolean,
    type: {
      type: String,
      default: "button",
    },
    icon: String,
    iconSize: String,
    iconColor: String,
    ripple: {
      type: Boolean,
      default: true,
    },
    rounded: Boolean,
    color: String,
    small: Boolean,
    fontSize: String,
    flat: Boolean,
    dataUiid: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped></style>
